module.exports = {"433126101":"古阳镇","433126103":"岩头寨镇","433126104":"默戎镇","433126105":"红石林镇","433126106":"断龙山镇","433126107":"高峰镇","433126108":"坪坝镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/433126.json
// module id = 2066
// module chunks = 0